var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "24px",
    height: "24px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,3c-1.65109,0 -3,1.34891 -3,3v12c0,1.65109 1.34891,3 3,3h12c1.65109,0 3,-1.34891 3,-3v-12c0,-1.65109 -1.34891,-3 -3,-3zM6,4h12c1.11091,0 2,0.88909 2,2v12c0,1.11091 -0.88909,2 -2,2h-12c-1.11091,0 -2,-0.88909 -2,-2v-12c0,-1.11091 0.88909,-2 2,-2zM8.18555,6.78516c-0.741,0 -1.18555,0.4442 -1.18555,1.0332c0,0.593 0.44438,1.03906 1.10938,1.03906c0.741,0 1.18164,-0.44606 1.18164,-1.03906c0,-0.588 -0.44047,-1.0332 -1.10547,-1.0332zM7.0625,9.96289v6.03711h2.17383v-6.03711zM11.0332,9.96289v6.03711h2.17383v-3.30273c0,-0.979 0.70111,-1.12305 0.91211,-1.12305c0.211,0 0.77344,0.21105 0.77344,1.12305v3.30273h2.10742v-3.30273c0,-1.891 -0.84548,-2.73438 -1.89648,-2.73438c-1.051,0 -1.61349,0.34975 -1.89649,0.84375v-0.84375z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.c825112c697d4a72d31e0ff78b0f06a3.svg";
export { ForwardRef as ReactComponent };